import React, { useState } from 'react';
import { apiFetch } from '../api/apiClient';
import { getAPIUrl } from '../api/apiUtils';

export default function LlmDebug() {
  const [busy, setBusy] = useState(false);
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState('');

  const sayHello = async () => {
    setBusy(true);
    setAnswer('');
    setError('');
    try {
      const response = await apiFetch(`${getAPIUrl()}/llm/hello`, { method: 'POST' });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || data.error || `Ошибка ${response.status}`);
      setAnswer(data.answer);
    } catch (err) {
      setError(err.message || 'Ошибка запроса');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="p-3">
      <h2>Отладка LLM</h2>
      <button className="btn btn-primary me-2" disabled={busy} onClick={sayHello}>
        {busy ? 'Ждём ответ…' : 'Привет'}
      </button>
      <button className="btn btn-outline-secondary" disabled={busy} onClick={() => { setAnswer(''); setError(''); }}>
        Очистить
      </button>
      <div className="mt-3" aria-live="polite">
        {error && <p className="text-danger" role="alert">{error}</p>}
        {answer && <pre style={{ whiteSpace: 'pre-wrap' }}>{answer}</pre>}
      </div>
    </section>
  );
}
